import React from 'react';

type LangCode = 'ru' | 'kz' | 'en';

interface LanguageTabsProps {
  value: LangCode;
  onChange: (lang: LangCode) => void;
  className?: string;
}

export default function LanguageTabs({ value, onChange, className }: LanguageTabsProps) {
  const tabs: Array<{ code: LangCode; label: string }> = [
    { code: 'ru', label: 'RU' },
    { code: 'kz', label: 'KZ' },
    { code: 'en', label: 'EN' }
  ];

  return (
    <div className={className || ''}>
      <div className="inline-flex rounded-md shadow-sm bg-gray-100 p-1">
        {tabs.map((t) => (
          <button
            key={t.code}
            type="button"
            onClick={() => onChange(t.code)}
            className={`px-3 py-1 text-sm rounded-md transition-colors ${
              value === t.code
                ? 'bg-blue-600 text-white shadow'
                : 'text-gray-700 hover:bg-white'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
    </div>
  );
}


